import React from 'react';
import PropTypes from 'prop-types';

const Plus = ({ style }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path d="M8 3V13" stroke="#ADADAD" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M13 8L3 8" stroke="#ADADAD" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

Plus.defaultProps = {
  style: {},
};

Plus.propTypes = {
  style: PropTypes.object,
};

export default Plus;
